export const FOURD_COLLECTION_REQUEST='FOURD_COLLECTION_REQUEST';
export const FOURD_COLLECTION_SUCCESS='FOURD_COLLECTION_SUCCESS';
export const FOURD_COLLECTION_FAIL='FOURD_COLLECTION_FAIL';

export const FOURD_BET_REQUEST='FOURD_BET_REQUEST';
export const FOURD_BET_SUCCESS='FOURD_BET_SUCCESS';
export const FOURD_BET_FAIL='FOURD_BET_FAIL';
